"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = require("./api");
var action_types_1 = require("./action-types");
exports.setClientData = function (client) { return ({ type: action_types_1.SET_CLIENT_DATA, client: client }); };
exports.setClientCountries = function (clientCountries) { return ({ type: action_types_1.SET_CLIENT_COUNTRIES, clientCountries: clientCountries }); };
exports.getClientData = function () { return function (dispatch) {
    return api_1.fetchCompanyBrandingAndRules().then(function (client) { return dispatch(exports.setClientData(client)); });
}; };
exports.getClientCountries = function () { return function (dispatch) {
    return api_1.fetchClientCountries().then(function (countries) { return dispatch(exports.setClientCountries(countries)); });
}; };
//# sourceMappingURL=actions.js.map